module.exports = __webpack_public_path__ + "static/ICONS_LongTerm-17ea524d2e14e4fd5a90d9b2c8cb46af.png";